/**
 * 店鋪選品優化（Overseas patch 226 建頁；231 脫離生態商城 → 獨立一級）
 */
export const STORE_ASSORTMENT_MENU_IDS = {
  group: 990455,
  desk: 990443,
  view: 990444,
  gate: 990456
}

export default STORE_ASSORTMENT_MENU_IDS



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/constants/storeAssortment.js